/* eslint-disable no-unused-vars */
import magnificPopup from '../../vendor/jquery.magnific-popup';
import throttle from '../../plugins/throttle';

export default () => {

  const communityLandingHeroVideo = $('.hero-video');
  communityLandingHeroVideo.muted = 'muted';

  if ($('.community-landing-hero-video-btn').length) {
    $('.community-landing-hero-video-btn .modal-video-button').magnificPopup({
      type: 'iframe',
      iframe: {
        patterns: {
          wistia: {
            index: 'wistia.com',
            id(url) {
              const m = url.match(/^.+wistia.com\/(medias)\/([^_]+)[^#]*(#medias=([^_&]+))?/);

              if (m !== null) {
                if (m[4] !== undefined) {
                  return m[4];
                }
                return m[2];
              }

              return null;
            },
            src: '//fast.wistia.net/embed/iframe/%id%?autoPlay=1'
          }
        }
      }
    });
  }

  if ($('.js-community-landing-icon-nav').length) {

    $('html').on('click', '.js-community-landing-icon-nav-mobile-toggle', (e) => {
      e.preventDefault();
      $(e.currentTarget).attr('data-open', $(e.currentTarget).attr('data-open') === 'true' ? 'false' : 'true').next().slideToggle(300);
    });

    $(window).on('resize', throttle(function() {
      if ($(window).width() > 899) {
        $('.js-community-landing-icon-nav-mobile-toggle').attr('data-open', 'false');
      }
    }, 100));

  }

};
